import classNames from "classnames";

import styles from "./ArrowToggle.module.scss";

interface ArrowToggleProps {
  opened?: boolean;
  width?: number;
  height?: number;
}

const ArrowToggle = ({
  opened = false,
  width = 12,
  height = 7,
}: ArrowToggleProps) => {
  return (
    <img
      src="/static/img/icons-v6/arrow-down-no-extra-space.svg"
      alt={opened ? "закрыть" : "открыть"}
      className={classNames(styles.arrow, {
        [styles.opened]: opened,
      })}
      width={width}
      height={height}
    />
  );
};

export default ArrowToggle;
